exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv[data-v-32828405]{width:1.81rem;height:1.81rem;background:-webkit-gradient(linear, left top, left bottom, from(#62cff8), to(#0879e9));background:linear-gradient(180deg, #62cff8 0%, #0879e9 100%);-webkit-box-shadow:-0.08rem .08rem .27rem 0px rgba(52,168,250,.56);box-shadow:-0.08rem .08rem .27rem 0px rgba(52,168,250,.56);border-radius:.91rem;position:absolute;right:.43rem;bottom:2.43rem;text-align:center;color:#fff\n}\ndiv p[data-v-32828405]:first-child{margin-top:.3rem\n}", ""]);

// exports
